"use client";

import {ICartItem} from "../interfaces/ICartItem";
import {IOrderPosition} from "../interfaces/IAccountOrder";

export interface GTagItem {
  item_id: string;
  item_name: string;
  affiliation?: string;
  coupon?: string;
  discount?: number;
  index?: number;
  item_brand?: string;
  item_category?: string;
  item_category2?: string;
  item_category3?: string;
  item_category4?: string;
  item_category5?: string;
  item_list_id?: string;
  item_list_name?: string;
  item_variant?: string;
  location_id?: string;
  price: number;
  quantity: number;
}

export interface GTagBeginCheckout {
  currency: string;
  value: number;
  coupon?: string;
  items: GTagItem[];
  email?: string;
}

export const beginCheckoutGEvent = (gtagBeginCheckout: GTagBeginCheckout, conversionsId: string) => {
  window.gtag('event', 'begin_checkout', gtagBeginCheckout);
};

export interface GTagPurchase {
  currency: string;
  value: number;
  transaction_id?: string;
  tax?: number;
  shipping?: number;
  coupon?: string;
  items: GTagItem[];
  email?: string;
}

export const purchaseGEvent = (gTagPurchase: GTagPurchase, conversionsId: string) => {
  window.gtag('event', 'purchase', gTagPurchase);
};

export interface GTagAddToCart {
  currency: string;
  value: number;
  items: GTagItem[];
}

export const addToCartGEvent = (gTagAddToCart: GTagAddToCart, conversionsId: string) => {
  window.gtag('event', 'add_to_cart', gTagAddToCart);
};

export function getGtagItemsFromPosition(items: IOrderPosition[]) : GTagItem[] {
  return items.map((item, index) => ({
    item_id: item.productId.toString(),
    item_name: item.productName,
    item_brand: item.brandId?.toString(),
    item_category: item.categoryId?.toString(),
    item_list_id: item.orderPosition.toString(),
    price: item.price,
    quantity: item.quantity,
  }))
}

export function getGTagItemsFromCart(items: ICartItem[]) : GTagItem[] {
  //TODO: Do discounts data

  //affiliation: "Google Merchandise Store", // Assuming a fixed value
  //coupon: "SUMMER_FUN", // Assuming a fixed value
  //discount: 0, // Assuming no discount unless specified
  //index: index,
  //item_category: "Apparel", // Assuming fixed values for categories
  //item_list_name: "Related Products", // Assuming a fixed value
  //location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo", // Assuming a fixed value
  //item_variant: item.product.slug,  Using slug for variant

  return items.map((item, index) => ({
    item_id: item.product.productID.toString(),
    item_name: item.product.slug,
    item_brand: item.product.brand,
    item_list_id: item.shoppingListId.toString(), // Converting to string
    price: item.product.price,
    quantity: item.quantity,
  }))
}

type EventType = 'begin_checkout' | 'purchase' | 'add_to_cart';

interface EventIds {
  [conversionId: string]: {
    [eventType in EventType]: string;
  };
}

// Define a lookup object for the event IDs
const eventIds: EventIds = {
  //MusiX
  "AW-1061256667": { //Conversion id
    begin_checkout: "H61aCOeSp7sZENv7hfoD",
    purchase: "HZE4CJzUj8ADENv7hfoD",
    add_to_cart: "ElpjCKi7obsZENv7hfoD"
  },
  //Venoa
  "AW-601914124": { //Conversion id
    begin_checkout: "73o3CMiI8t0CEIz2gZ8C",
    purchase: "uQB3CLi-iqoDEIz2gZ8C",
    add_to_cart: "7dIhCIrKi90CEIz2gZ8C"
  }
};

// Function to get event ID based on conversion ID and event type
export const getEventId = (conversionId: keyof EventIds, eventType: EventType): string | undefined => {
  return eventIds[conversionId] ? eventIds[conversionId][eventType] : undefined;
};

